module.exports = __webpack_public_path__ + "img/Group 1864.be070fee.svg";